import { CommitmentSourcesService_commitmentSourcesServiceGetCommitmentStates } from '@festina/life-general-types/life/hooks/CommitmentSourcesCommitmentStatesService_commitmentSourcesServiceGetCommitmentStates'

export const useFetchCommitmentState =
  CommitmentSourcesService_commitmentSourcesServiceGetCommitmentStates.useSuspenseQuery
